import { render } from "./DetailVillagerModal.vue?vue&type=template&id=6f451ddf&scoped=true"
import script from "./DetailVillagerModal.vue?vue&type=script&lang=js"
export * from "./DetailVillagerModal.vue?vue&type=script&lang=js"

import "./DetailVillagerModal.vue?vue&type=style&index=0&id=6f451ddf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f451ddf"]])

export default __exports__